import React, { useContext, useEffect } from "react";
import styles from './DeploymentLogs.module.scss'
import { DEPLOYMENTS_LOGS_STORAGE_NAME } from "../../../../../settings/global";
import { FoldingContentContext } from "../../../../../components/folding/FoldingContent";

function DeploymentLogs({deployment, deploymentLoading, custom}) {

    const foldingContext = useContext(FoldingContentContext)

    const commonLogs = JSON.parse(localStorage.getItem(DEPLOYMENTS_LOGS_STORAGE_NAME) || `{}`);
    const logs = commonLogs[deployment.id] || commonLogs[deployment._id] || [];

    useEffect(() => {
        if (foldingContext) setTimeout(() => foldingContext?.recalculateHeight(), 100);
        // this is required for live update of logs
        // without it only already created logs will appear
        window.addEventListener('storage', () => {
            if (foldingContext) foldingContext?.recalculateHeight();
        })
    }, []);

    useEffect(() => {
        if (custom && !deploymentLoading && foldingContext) {
            setTimeout(() => foldingContext?.recalculateHeight(), 100);
        }
    }, [deploymentLoading]);

    const padTo2Digits = num => String(num).padStart(2, '0');

    const renderLogs = logs => {
        return logs.map((log, index) => {
            const time = new Date(log.timestamp);
            return (
                <div className={styles.log} key={index}>
                    <p className={styles.log__message}>{log.message}</p>
                    <time className={styles.log__timestamp}>
                        {padTo2Digits(time.getHours())}:{padTo2Digits(time.getMinutes())}
                    </time>
                </div>
            )
        })
    }

    const deploymentDate = new Date(!custom ? deployment.date_created : deployment._created);

    return (
        <div style={custom ? {borderRadius: '18px'} : {}} className={styles.logs} data-empty={!logs.length}>
            <p className={styles.logs__title}>
                Created {' '}
                {padTo2Digits(deploymentDate.getHours())}:{padTo2Digits(deploymentDate.getMinutes())} {' '}
                {padTo2Digits(deploymentDate.getMonth() + 1)}/
                {padTo2Digits(deploymentDate.getDate())}/
                {padTo2Digits(deploymentDate.getFullYear())} {' '}
                (UTC+00:00)
            </p>
            {renderLogs(logs)}
        </div>
    );
}

export default DeploymentLogs